import { defineGuideTourConfig } from '@/guide-tour/config'
import { createGuideTourRegistry } from '@/guide-tour/registry'

/**
 * Config do Seller. `toursRoot: '.'` = esta pasta (`src/tours/`).
 */
export const guideTourConfig = defineGuideTourConfig({
  toursRoot: '.',

  observers: {
    // Detecção apenas: classe do overlay escuro dentro do shadow do dialog Hexa V2.
    // Não fecha modal — só informa à lib que ainda há modal aberta (waitForModalHidden).
    modalBackdropClass: 'backdrop',
    modalHostSelectors: ['hexa-v2-dialog', 'hexa-v2-modal', 'hexa-v2-drawer'],
    detectFullscreenBlockingOverlay: true,
  },

  // ui: {
  //   skippedStepNoticeMs: 5_000, // default da lib; sobrescreva se precisar
  // },

  // isNewUser é opcional. Responde só: "este usuário já conhece a plataforma?"
  // O storage (localStorage) responde outra coisa: "este tour já foi visto?"
  //
  // Retorno de isNewUser():
  //   undefined → ainda carregando (ex.: API). Lib espera e reavalia.
  //   false     → usuário retornando. Bloqueia tours automáticos (mesmo storage vazio).
  //   true      → não bloqueia por perfil. Lib segue para o storage por tour.
  //
  // Sem isNewUser configurado → pula essa etapa; só o storage por tour decide.
  //
  // Exemplo com API:
  // isNewUser: () => {
  //   if (sellerProfile.isLoading) return undefined
  //   if (sellerProfile.data?.isFirstAccess === false) return false
  //   // API sem campo ou isFirstAccess === true → não bloqueia; storage decide por tour
  //   return true
  // },
})

const sellerGuideTourSetup = createGuideTourRegistry(guideTourConfig)

export const guideTourDefinitions = sellerGuideTourSetup.guideTourDefinitions
export const sellerGuideTourRegistry = sellerGuideTourSetup.registry
